<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :mask-closable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    :ok-text="$t('确定')"
    :cancel-text="$t('关闭')"
    :ok-button-props="{ class: { 'jee-hidden': disableSubmit } }"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" slot="detail" :model="formData" :rules="validatorRules" :colon="false">
          <a-row v-if="false" :gutter="[24, 16]">
            <a-col :span="12">
              <a-form-model-item :label="$t('用户类型')" prop="repairCreateOrderUserType">
                <a-radio-group v-model="formData.model.repairCreateOrderUserType">
                  <a-radio :value="0"> {{ $t('非系统用户') }} </a-radio>
                  <a-radio :value="1"> {{ $t('系统用户') }} </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-divider class="aDividerBlue" orientation="left">{{ $t('工单信息') }}</a-divider>
          <detail-list :col="3">
            <detail-list-item :term="$t('工单编号')">{{ formData.model.ticketsNum }}</detail-list-item>
            <detail-list-item :term="$t('工单类型')">{{ formData.model.ticketsType == 2 ? $t('故障报修') : $t('水厂报修') }}</detail-list-item>
            <detail-list-item :term="$t('工单联系人')">{{ formData.model.ticketsContact }}</detail-list-item>
          </detail-list>
          <detail-list :col="3">
            <detail-list-item :term="$t('紧急程度')">
              <a-tag :color="getTagColor(formData.model.ticketsEmergency)">
                {{ setJJ(formData.model.ticketsEmergency) }}
              </a-tag>
            </detail-list-item>
            <detail-list-item v-if="formData.model.ticketsType == 2" :term="$t('预约时间')">{{ formData.model.ticketsDeadline }}</detail-list-item>
            <detail-list-item :term="$t('联系电话')">{{ formData.model.ticketsContactPhone }}</detail-list-item>
            <!-- <detail-list-item term="地理信息">{{formData.model.ticketsLocation}}</detail-list-item> -->
          </detail-list>
          <!-- <detail-list :col="3">
            <detail-list-item
              term="换表原因"
              v-if="formData.model.ticketsChangeMeter?.changingMeterReason"
              :itemCol="1"
            >
              {{ changingMeterReason }}
            </detail-list-item>
          </detail-list> -->

          <!-- 保修- 系统用户 -->
          <template v-if="formData.model.repairCreateOrderUserType == 1">
            <a-divider class="aDividerBlue" orientation="left"> {{ $t('用户信息') }} </a-divider>
            <detail-list :col="3">
              <detail-list-item :term="$t('用户编号')">
                {{ formData.oldMeter.userId }}
              </detail-list-item>
              <detail-list-item :term="$t('用户姓名')">
                {{ formData.oldMeter.userName }}
              </detail-list-item>
              <detail-list-item :term="$t('手机号码')">
                {{ formData.oldMeter.userPhone }}
              </detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('开户时间')">
                {{ formData.oldMeter.userCreateTime }}
              </detail-list-item>
              <detail-list-item :term="$t('用水性质')">
                {{ formData.oldMeter.wtName }}
              </detail-list-item>
              <detail-list-item :term="$t('用水状态')">
                {{
                  formData.oldMeter.userState == 0 ? $t('未开始计费') : formData.oldMeter.userState == 1 ? $t('已开始计费') : ''
                }}
              </detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('区域信息')" :itemCol="1">
                {{ formData.oldMeter.userAreaName }}
              </detail-list-item>
              <detail-list-item :term="$t('用户地址')" :itemCol="1">
                {{ formData.oldMeter.userAddr }}
              </detail-list-item>
              <!-- <detail-list-item term="用户地址" :itemCol="2">{{meterInfo.userAreaName.slice(meterInfo.userAreaName.indexOf('-')+1,meterInfo.userAreaName.length)+'-'+meterInfo.userAddr}}</detail-list-item> -->
            </detail-list>

            <!-- <detail-list :col="3"> -->
            <!-- <detail-list-item term="开户时间">{{formData.oldMeter.userCreateTime}}</detail-list-item> -->
            <!-- <detail-list-item term="用户地址">{{formData.oldMeter.userAddr}}</detail-list-item> -->
            <!-- <detail-list-item :itemCol="1" term="用户地址">{{formData.oldMeter.userAreaName && formData.oldMeter.userAreaName.slice(formData.oldMeter.userAreaName.indexOf('-')+1,formData.oldMeter.userAreaName.length)+'-'+formData.oldMeter.userAddr}}</detail-list-item> -->
            <!-- </detail-list> -->

            <a-divider class="aDividerBlue" orientation="left"> {{ $t('旧表信息') }} </a-divider>
            <detail-list :col="3">
              <detail-list-item :term="$t('旧表编号')">
                {{ formData.oldMeter.meterId }}
              </detail-list-item>
              <!-- <detail-list-item term="用水性质">{{formData.oldMeter.wtName}}</detail-list-item> -->
              <detail-list-item :term="$t('水表厂家')">
                {{ formData.oldMeter.meterTypeName }}
              </detail-list-item>
              <detail-list-item :term="$t('口径')">
                {{ formData.oldMeter.mtCaliber ? 'DN' + formData.oldMeter.mtCaliber : '' }}
              </detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('表计费起始读数')">
                {{ formData.oldMeter.oldMeterStartNum }}
              </detail-list-item>
              <detail-list-item :term="$t('末次上报结算流量(m³)')">
                {{ formData.oldMeter.oldUserCalNum }}
              </detail-list-item>
              <detail-list-item :term="$t('末次上报结算余额(元)')">
                {{ formData.oldMeter.userAccountNum }}
              </detail-list-item>
            </detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('末次上报日期')">
                {{ formData.oldMeter.meterUpTime }}
              </detail-list-item>
            </detail-list>

            <!-- <detail-list :col="3">
                  <detail-list-item term="旧表机械读数(m³)">{{formData.oldMeter.meterOldMachineSumFlow? formData.oldMeter.meterOldMachineSumFlow: formData.oldMeter.oldUserCalNum }}</detail-list-item>
                  <detail-list-item term="剩余金额(元)">{{formData.oldMeter.meterUserAccountNumAfterChange? formData.oldMeter.meterUserAccountNumAfterChange: formData.oldMeter.userAccountNum }}</detail-list-item>
              </detail-list> -->
          </template>
          <!-- 保修- 非系统用户 -->
          <template v-if="formData.model.repairCreateOrderUserType == 0">
            <a-divider class="aDividerBlue" orientation="left"> {{ $t('报修信息') }} </a-divider>
            <detail-list :col="3">
              <detail-list-item :term="$t('报修人名称')">
                {{ formData.model.repairName }}
              </detail-list-item>
              <detail-list-item :term="$t('报修人电话')">
                {{ formData.model.repairPhone }}
              </detail-list-item>
              <detail-list-item v-if="formData.model.ticketsType == 2" :term="$t('报修地址')">{{ formData.model.repairAddress }}</detail-list-item>
              <detail-list-item v-if="formData.model.ticketsType == 11" :term="$t('设备信息')">{{ formData.model.repairAddress }}</detail-list-item>
            </detail-list>
          </template>
          <!-- 报修- 报修信息-->
          <template>
            <a-divider class="aDividerBlue" orientation="left"> {{ $t('报修信息') }} </a-divider>
            <detail-list :col="3">
              <detail-list-item :item-col="1" :term="$t('报修描述')">
                {{ formData.model.repairDescription }}
              </detail-list-item>
            </detail-list>
            <detail-list>
              <detail-list-item :term="$t('报修图片')" style="display: flex; width: 100%">
                <j-image-upload
                  v-model="formData.model.repairPicture"
                  class="avatar-uploader"
                  :text="$t('上传')"
                  style="display: block"
                  disabled
                  :is-multiple="true"
                />
              </detail-list-item>
            </detail-list>
          </template>
          <!-- 报修- 处理信息 -->
          <template>
            <a-divider class="aDividerBlue" orientation="left"> {{ $t('处理信息') }} </a-divider>
            <a-row :gutter="24">
              <!-- 非系统用户只有处理描述 与 处理图片 -->
              <a-col v-if="formData.model.repairCreateOrderUserType == 1" :span="8">
                <a-form-model-item :label="$t('是否换表')" :prop="'model.ifNeedChangeMeter'">
                  <a-select
                    v-model="formData.model.ifNeedChangeMeter"
                    :placeholder="$t('请选择是否换表')"
                    :disabled="notInput"
                    @change="handleChangeIfNeedChangeMeter"
                  >
                    <a-select-option :value="1"> {{ $t('换表') }} </a-select-option>
                    <a-select-option :value="0"> {{ $t('不换表') }} </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <!-- 报修  系统用户 换表  -->
            <a-row v-if="formData.model.repairCreateOrderUserType == 1 && formData.model.ifNeedChangeMeter == 1">
              <a-divider class="aDividerBlue" orientation="left"> {{ $t('新表具信息') }} </a-divider>
              <a-button
                v-if="!notInput"
                type="primary"
                style="margin-bottom: 10px"
                :disabled="notInput"
                icon="plus"
                @click="selectNewMeter"
              >
                {{ $t('选择新表') }}
              </a-button>
              <detail-list>
                <detail-list :col="3">
                  <detail-list-item :term="$t('新表编号')">
                    {{ formData.newMeter.newMeterId }}
                  </detail-list-item>
                  <!-- <detail-list-item term="用水性质">{{oldMeter.wtName}}</detail-list-item> -->
                  <detail-list-item :term="$t('新表厂商')">
                    {{ formData.newMeter.newMtName }}
                  </detail-list-item>
                  <detail-list-item :term="$t('口径')">
                    {{ formData.newMeter.newMtCaliber ? 'DN' + formData.newMeter.newMtCaliber : '' }}
                  </detail-list-item>
                </detail-list>
              </detail-list>

              <a-divider class="aDividerBlue" orientation="left"> {{ $t('换表操作') }} </a-divider>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item :label="$t('旧表机械读数(m³)')" :prop="'oldMeter.meterOldMachineSumFlow'">
                    <a-input-number
                      v-model="formData.oldMeter.meterOldMachineSumFlow"
                      :placeholder="$t('请输入旧表机械读数')"
                      style="width: 100%"
                      :min="0"
                      :precision="2"
                      :disabled="notInput"
                      @change="meterOldMachineSumFlowInput"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('新表开始计费读数(m³)')" :prop="'newMeter.meterStartNum'">
                    <a-input-number
                      v-model="formData.newMeter.meterStartNum"
                      :min="0"
                      :precision="2"
                      style="width: 100%"
                      :placeholder="$t('请输入起始读数')"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理前照片')" :prop="'model.resolvedPictureFront'">
                    <j-image-upload
                      v-model="formData.model.resolvedPictureFront"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理后照片')" :prop="'model.resolvedPictureOpposite'">
                    <j-image-upload
                      v-model="formData.model.resolvedPictureOpposite"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item
                    :label="$t('是否以旧表机械读数结算')"
                    :prop="'oldMeter.whetherSettlementOldTable'"
                    :rules="whetherSettlementOldTableRules"
                  >
                    <a-select
                      v-model="formData.oldMeter.whetherSettlementOldTable"
                      :placeholder="$t('请选择是否以旧表机械读数结算')"
                      :allowClear="true"
                      @change="whetherSettlementOldTableChange"
                    >
                      <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('否') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item :label="$t('是否收费')" :prop="'model.payOrNot'">
                    <a-select
                      v-model="formData.model.payOrNot"
                      :placeholder="$t('请选择是否收费')"
                      :disabled="notInput"
                      @change="payOrNotChange"
                    >
                      <a-select-option :value="1">{{ $t('收费') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('不收费') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>

              
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item
                    :label="$t('剩余金额(元)')"
                    :rules="meterUserAccountNumAfterChangeRules"
                    :prop="'oldMeter.meterUserAccountNumAfterChange'"
                    >
                    <a-input-number
                      v-model="formData.oldMeter.meterUserAccountNumAfterChange"
                      :suffix="$t('元')"
                      :precision="2"
                      style="width: 100%"
                      :placeholder="$t('请输入剩余金额')"
                      :disabled="formData.oldMeter.whetherSettlementOldTable == 1"
                      />
                    </a-form-model-item>
                  </a-col>
                  
                  <a-col :span="12">
                    <a-form-model-item :label="$t('换表原因')" prop="model.changingMeterReason">
                      <a-cascader
                      v-model="changingMeterReason"
                      :options="options"
                      expand-trigger="hover"
                      :placeholder="$t('请选择换表原因')"
                      :disabled="notInput"
                      @change="onChange"
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                
                <a-row :gutter="24" v-if="notInput">
                  <a-col :span="24">
                    <a-form-model-item :label="$t('电子签名')" prop="payMoney">
                      <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false" v-if="formData.model.electronicSignature">
                        <img style="width: 180px; height: 80px" :src="formData.model.electronicSignature" />
                        <div class="mask-sig" :class="{ 'mask-show': isShow }">
                          <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                          <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                        </div>
                      </div>
                      <i v-else>{{ $t('暂无签名') }}</i>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              <a-row :gutter="24">
                <a-col v-if="formData.model.payOrNot == 1" :span="12">
                  <a-form-model-item :label="$t('付款码')" prop="paymentCode">
                    <a-upload
                      action=""
                      list-type="picture-card"
                      :file-list="qrcodeImage"
                      @preview="handlePreview"
                      disabled
                    >
                    </a-upload>
                  </a-form-model-item>
                </a-col>
                <a-col v-if="formData.model.payOrNot == 1" :span="12">
                  <a-form-model-item :label="$t('支付凭证')" prop="model.infoPicture">
                    <j-image-upload
                      v-model="formData.model.infoPicture"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                      @change="handleImageChange"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24" v-if="formData.model.payOrNot == 1">
                <a-col :span="12">
                  <a-form-model-item
                    :label="$t('收费金额(元)')"
                    prop="model.feeAmount"
                  >
                    <a-input-number
                      v-model="formData.model.feeAmount"
                      :suffix="$t('元')"
                      :precision="2"
                      :min="0"
                      style="width: 100%"
                      :placeholder="$t('请输入收费金额')"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('协议书照片')" prop="model.protocolPicture">
                    <j-image-upload
                      v-model="formData.model.protocolPicture"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                      @change="handleImageChange"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-row>

            <!-- 非系统用户 或者 不换表 显示 -->
            <a-row v-if="formData.model.repairCreateOrderUserType == 0 || formData.model.ifNeedChangeMeter == 0">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理前照片')" :prop="'model.resolvedPictureFront'">
                    <j-image-upload
                      v-model="formData.model.resolvedPictureFront"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理后照片')" :prop="'model.resolvedPictureOpposite'">
                    <j-image-upload
                      v-model="formData.model.resolvedPictureOpposite"
                      class="avatar-uploader"
                      :text="$t('上传')"
                      :is-multiple="true"
                      :disabled="notInput"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-row>

            <a-row v-if="!notInput" :gutter="24">
              <a-col :span="24">
                <a-form-model-item :label="$t('处理描述')" prop="model.handleUserDescription">
                  <a-textarea
                    v-model="formData.model.handleUserDescription"
                    :disabled="notInput"
                    :placeholder="$t('请输入处理描述')"
                    :rows="4"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row v-if="notInput" :gutter="24">
              <a-col :span="24">
                <detail-list :col="3">
                  <detail-list-item :term="$t('处理描述')" :itemCol="1">{{
                    formData.model.handleUserDescription && formData.model.handleUserDescription
                  }}</detail-list-item>
                </detail-list>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('备注')" prop="notInputRemark">
                  <a-textarea v-model="notInputRemark" :placeholder="$t('请输入备注信息')" :rows="4" />
                </a-form-model-item>
              </a-col>
            </a-row>
            
          </template>
        </a-form-model>
      </j-form-container>
    </a-spin>

    <!-- 选择新表弹窗 -->
    <SelectNewMeterModal
      :visible="selectNewMeterModalVisible"
      @update:visible="val => (selectNewMeterModalVisible = val)"
      @ok="handleMeterSelected"
    />
    <j-modal
      :title="$t('预览')"
      :width="448"
      :visible="visibleSig"
      @cancel="handleSigCancel"
      :okButtonProps="{ class: { 'jee-hidden': true } }"
    >
      <div style="width: 400px; height: 400px">
        <img :src="formData.model&&formData.model.ticketsChangeMeter&&formData.model.ticketsChangeMeter.electronicSignature" alt="" style="width: 100%; height: 100%" />
      </div>
    </j-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel1">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </j-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JUpload from '@/components/jeecg/JUpload'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import JInput from '@/components/jeecg/JInput'
import { PhoneNumberPattern } from '@/utils/regPattern'
import SelectNewMeterModal from './selectNewMeter.vue'
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import DetailList from '@/components/tools/DetailList'
const DetailListItem = DetailList.Item
import {fileUrl} from'@/utils/util'
export default {
  name: 'AuditModal',
  components: {
    DetailList,
    DetailListItem,
    JImageUpload,
    JUpload,
    JInput,
    SelectNewMeterModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      remark: '',
      notInput: false, // 审批 不允许输入
      optionType: '', // 操作类型
      formData: {
        model: {
          ticketsEmergency: null,
          ifNeedChangeMeter: null,
          infoPicture: null,
        }, // 工单信息
        userInfo: {}, // 系统用户信息
        oldMeter: {
          whetherSettlementOldTable: null,
          meterOldMachineSumFlow: '',
          meterUserAccountNumAfterChange: '',
        }, // 旧表信息
        newMeter: {}, // 新表信息
      }, // 表单信息
      qrcodeImage: [
        {
          uid: '-1',
          name: '付款码',
          status: 'done',
          url: fileUrl+'/file/payment_code.png',
        }
      ],
      previewVisible: false,
      previewImage: '',
      url: {
        pass: '/jeecg-engineering/flowable/task/completeByDateId',
        reject: '/jeecg-engineering/flowable/task/taskRejectByDataId',
        queryById: '/jeecg-engineering/ticket/tickets/queryById',
        edit: '/jeecg-engineering/engineering/meterRepair/edit',
        useOldMachineSumFlow: '/jeecg-charge/meter/meteChangeMeterRecord/useOldMachineSumFlow', //是否以旧表读数结算
        newMeterInfo: '/jeecg-charge/meter/meterinfo/list', //新表接口
        list: '/jeecg-charge/meter/meterUserinfo/list',
        userList: '/sys/user/list',
        getMeterUserInfoByKeyId: '/jeecg-charge/meter/meteChangeMeterRecord/getMeterUserInfoByKeyId', //换表请求
      },
      candidateUsersList: [],
      meterRepair: {},
      fileList: '',
      selectNewMeterModalVisible: false,
      changingMeterReason: [],
      notInputRemark: '',
      isShow: false,
      visibleSig: false,
    }
  },
  watch: {
    'model.audit': {
      handler(val) {
        if (val == 1) {
          this.validatorRules.remark.required = false
        } else {
          this.validatorRules.remark.required = true
        }
      },
    },
    'model.handleUserName': {
      handler(val) {
        if (val) {
          let info = this.candidateUsersList.find(item => item.username == val)
          this.$set(this.formData.model, 'handleUserRealName', info.realname)
          this.$set(this.formData.model, 'handleUserPhone', info.telephone || info.phone)
        }
      },
    },
  },
  computed: {
    validatorRules() {
      return {
        'model.ticketsEmergency': [{ required: true, message: this.$t('请选择紧急程度'), trigger: 'change' }],
        'model.repairPicture': [{ required: true, message: this.$t('请上传报修图片'), trigger: 'change' }],
        'model.repairDescription': [{ required: true, message: this.$t('请输入报修描述'), trigger: 'change' }],
        'model.ifNeedChangeMeter': [{ required: true, message: this.$t('请选择是否换表'), trigger: 'change' }],
        'model.resolvedPictureFront': [{ required: true, message: this.$t('请上传处理前图片'), trigger: 'change' }],
        'model.resolvedPictureOpposite': [{ required: true, message: this.$t('请上传处理后图片'), trigger: 'change' }],
        'oldMeter.meterOldMachineSumFlow': [{ required: true, message: this.$t('请输入旧表机械读数'), trigger: 'change' }],
        'oldMeter.meterUserAccountNumAfterChange': [
          { required: true, message: this.$t('请输入换表后账户剩余金额'), trigger: 'change' },
        ],
        'oldMeter.whetherSettlementOldTable': [
          { required: false, message: this.$t('请选择是否以旧表机械读数结算'), trigger: 'change' },
        ],
        'newMeter.meterStartNum': [{ required: true, message: this.$t('请输入新表开始计费读数'), trigger: 'change' }],
        'model.payOrNot': [{ required: false, message: this.$t('请选择是否收费'), trigger: 'change' }],
        'model.infoPicture': [{ required: true, message: this.$t('请上传支付凭证'), trigger: ['change', 'blur'] }],
        'model.handleUserDescription': [{ required: true, message: this.$t('请输入处理描述'), trigger: ['change', 'blur'] }],
        'model.changingMeterReason': [{ required: true, message: this.$t('请选择换表原因'), trigger: ['change', 'blur'] }],
        'model.feeAmount': [{ required: true, message: this.$t('请输入收费金额'), trigger: ['change', 'blur'] }],
        'model.protocolPicture': [{ required: true, message: this.$t('请上传协议书照片'), trigger: ['change', 'blur'] }],
      }
    },
    options() {
      const t = this.$t
      return [
        {
          value: '0',
          label: t('周期性换表'),
        },
        {
          value: '1',
          label: t('故障换表'),
          children: [
            {
              value: '2',
              label: t('基表问题'),
              children: [
                {
                  value: '3',
                  label: t('计量问题'),
                },
                {
                  value: '4',
                  label: t('阀门故障'),
                },
                {
                  value: '5',
                  label: t('基表爆裂'),
                },
              ],
            },
            {
              value: '6',
              label: t('电子问题'),
              children: [
                {
                  value: '7',
                  label: t('不上传数据'),
                },
                {
                  value: '8',
                  label: t('水表无反应（黑屏，无法激活）'),
                },
              ],
            },
            {
              value: '9',
              label: t('磁干扰'),
            },
            {
              value: '10',
              label: t('缺电'),
            },
            {
              value: '11',
              label: t('其他'),
            },
          ],
        },
      ]
    },
    whetherSettlementOldTableRules() {
      // 根据 notInput 的值动态设置是否必填
      return this.notInput ? [{ required: true, message: this.$t('请选择是否以旧表机械读数结算'), trigger: 'change' }] : []
    },
    meterUserAccountNumAfterChangeRules() {
      // 根据 notInput 的值动态设置是否必填
      return this.notInput ? [{ required: true, message: this.$t('请输入剩余金额'), trigger: 'blur' }] : []
    },
  },
  methods: {
    getUserList() {
      this.candidateUsersList = []
      getAction(this.url.userList, { status: 1, pageSize: 999 }).then(res => {
        if (res.success) {
          this.candidateUsersList = {
            ...res.result.records,
          }
        }
      })
    },
    init(row, type) {
      let that = this
      this.title = this.$t(type)
      this.optionType = type
      if (type == '审核') {
        that.notInput = true
      } else {
        // 处理
        that.notInput = false
      }
      this.visible = true
      that.confirmLoading = false
      this.formData = {
        model: {
          id: row.id,
          ticketsType: row.ticketsType,
          ticketsId: row.id,
        }, // 工单信息
        userInfo: {}, // 系统用户信息
        oldMeter: {}, // 旧表信息
        newMeter: {
          whetherSettlementOldTable: null,
          meterOldMachineSumFlow: '',
          meterUserAccountNumAfterChange: '',
        }, // 新表信息
      }

      this.getUserList()
      // 获取工单数据
      getAction(this.url.queryById, { id: row.id }).then(res => {
        if (res.success) {
          that.meterRepair = res.result.wechatMeterRepair

          this.$set(this.formData, 'model', {
            ...res.result,
            bzId: res.result.wechatMeterRepair.id,
            // 报修人信息
            repairName: res.result.wechatMeterRepair.repairName,
            repairPhone: res.result.wechatMeterRepair.repairPhone,
            repairAddress: res.result.wechatMeterRepair.repairAddress,
            repairTime: res.result.wechatMeterRepair.repairTime,
            repairPicture: res.result.repairPicture,
            repairDescription: res.result.wechatMeterRepair.repairDescription,
            // 预约时间
            dealTime: res.result.ticketsDeadline,
            // 是否解决
            solveStatus: res.result.wechatMeterRepair.isSolve,
            // 处理人
            handleUserName: res.result.wechatMeterRepair.handleUserName,
            handleUserRealName: res.result.wechatMeterRepair.handleUserRealName,
            handleUserPhone: res.result.wechatMeterRepair.handleUserPhone,
            handleUserDescription: res.result.wechatMeterRepair.handleUserDescription,
            handleUserTime: res.result.wechatMeterRepair.handleUserTime,
            resolvedPictureFront: res.result.resolvedPictureFront,
            resolvedPictureOpposite: res.result.resolvedPictureOpposite,

            // fixPhone: res.result.wechatMeterRepair.fixPhone,
            // fixDescription: res.result.wechatMeterRepair.fixDescription,
            // fixPicture: res.result.wechatMeterRepair.fixPicture,
            userId: res.result.wechatMeterRepair.userId,
            userName: res.result.wechatMeterRepair.userName,
            userIdNumber: res.result.wechatMeterRepair.userIdNumber,
            mtName: res.result.wechatMeterRepair.mtName,
            userPhone: res.result.wechatMeterRepair.userPhone,
            meterId: res.result.wechatMeterRepair.meterId,
            ifNeedChangeMeter: 0,
          })
          // 判断是否是系统用户
          if (that.formData.model.wechatMeterRepair.userId) {
            // 系统用户
            this.$set(that.formData.model, 'repairCreateOrderUserType', 1)

            // 查询系统用户绑定的 旧表信息
            getAction(this.url.list, { userId: that.formData.model.wechatMeterRepair.userId }).then(res => {
              if (res.success) {
                this.$set(that.formData, 'oldMeter', { ...res.result.records[0] })
                that.setOldMeterNum()
                // 旧表机械读数 计算 剩余金额
                // this.meterOldMachineSumFlowInput()
              }
              // 已解决 换表的工单 则取 记录值
              if (that.formData.model.ticketsChangeMeter && that.formData.model.ticketsChangeMeter.oldMeterId) {
                // 表计费起始读数
                this.$set(
                  that.formData.oldMeter,
                  'oldMeterStartNum',
                  that.formData.model.ticketsChangeMeter.oldMeterStartNum
                )
                // 末次上报结算流量
                this.$set(that.formData.oldMeter, 'oldUserCalNum', that.formData.model.ticketsChangeMeter.oldUserCalNum)
                // 末次上报结算余额
                this.$set(
                  that.formData.oldMeter,
                  'userAccountNum',
                  that.formData.model.ticketsChangeMeter.userAccountNum
                )
                this.$set(that.formData.oldMeter, 'meterUpTime', that.formData.model.ticketsChangeMeter.meterUpTime)
              } else {
                // 否则取 实时值
                getAction(that.url.getMeterUserInfoByKeyId, { userKeyId: that.formData.oldMeter.id }).then(res => {
                  if (res.success) {
                    this.$set(that.formData.oldMeter, 'oldMeterStartNum', that.formData.oldMeter.userMeterStartNum)
                    this.$set(that.formData.oldMeter, 'oldUserCalNum', res.result.userCalNum)
                    this.$set(that.formData.oldMeter, 'userAccountNum', res.result.userAccountNum)
                    this.$set(that.formData.oldMeter, 'meterUpTime', res.result.meterUpTime)
                  }
                })
              }
            })
            // 是否存在换表 体
            if (that.formData.model.ticketsChangeMeter) {
              if (that.formData.model.ticketsChangeMeter.newMeterId) {
                this.$set(that.formData.model, 'ifNeedChangeMeter', 1)
                this.$set(that.formData.model, 'electronicSignature', that.formData.model.ticketsChangeMeter.electronicSignature)

                if (
                  that.formData.model.ticketsChangeMeter &&
                  that.formData.model.ticketsChangeMeter.changingMeterReason != null
                ) {
                  this.$set(
                    that.formData.model,
                    'changingMeterReason',
                    that.formData.model.ticketsChangeMeter.changingMeterReason
                  )
                  // 将后端返回的最后一层值转换为完整路径
                  const fullPath = that.findCascaderPath(that.formData.model.ticketsChangeMeter.changingMeterReason)
                  that.changingMeterReason = fullPath
                }
                // 换表
                // 新表数据
                let params = {
                  meterId: that.formData.model.ticketsChangeMeter.newMeterId,
                }
                getAction(this.url.newMeterInfo, params).then(res => {
                  if (res.success) {
                    let selectedMeter = res.result.records[0]
                    this.$set(that.formData, 'newMeter', { ...res.result.records[0] })

                    // 新表编号 新表口径 新表厂商 新表开始计费读数
                    this.$set(that.formData.newMeter, 'newMeterId', selectedMeter.meterId)
                    this.$set(that.formData.newMeter, 'newMtCaliber', selectedMeter.mtCaliber)
                    this.$set(that.formData.newMeter, 'newMtName', selectedMeter.mtName)
                    this.$set(
                      that.formData.newMeter,
                      'meterStartNum',
                      that.formData.model.ticketsChangeMeter.meterStartNum
                    )
                    // 是否收费
                    if (that.formData.model.infoPicture) {
                      this.$set(that.formData.model, 'payOrNot', 1)
                      this.$set(that.formData.model, 'feeAmount', that.formData.model.ticketsChangeMeter.feeAmount)
                      this.$set(that.formData.model, 'protocolPicture', that.formData.model.ticketsChangeMeter.protocolPicture)
                    } else {
                      this.$set(that.formData.model, 'payOrNot', 0)
                    }
                  }
                })
              } else {
                // 不需要换表
                this.$set(that.formData.model, 'ifNeedChangeMeter', 0)
              }
            } else {
              // 不需要换表
              this.$set(that.formData.model, 'ifNeedChangeMeter', 0)
            }
          } else {
            // 非系统用户
            this.$set(that.formData.model, 'repairCreateOrderUserType', 0)
          }
        }
      })
      // 清空表单验证
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    setOldMeterNum() {
      if (
        this.formData.model.ticketsChangeMeter &&
        this.formData.model.ticketsChangeMeter.whetherSettlementOldTable != null
      ) {
        // 是否旧表结算
        this.$set(
          this.formData.oldMeter,
          'whetherSettlementOldTable',
          this.formData.model.ticketsChangeMeter.whetherSettlementOldTable
        )
      } else {
        this.$set(this.formData.oldMeter, 'whetherSettlementOldTable', null)
      }
      if (
        this.formData.model.ticketsChangeMeter &&
        this.formData.model.ticketsChangeMeter.meterOldMachineSumFlow != null
      ) {
        // 旧表机械读数
        this.$set(
          this.formData.oldMeter,
          'meterOldMachineSumFlow',
          this.formData.model.ticketsChangeMeter.meterOldMachineSumFlow
        )
      } else {
        this.$set(this.formData.oldMeter, 'meterOldMachineSumFlow', '')
      }
      if (
        this.formData.model.ticketsChangeMeter &&
        this.formData.model.ticketsChangeMeter.meterUserAccountNumAfterChange != null
      ) {
        // 剩余金额
        this.$set(
          this.formData.oldMeter,
          'meterUserAccountNumAfterChange',
          this.formData.model.ticketsChangeMeter.meterUserAccountNumAfterChange
        )
      } else {
        this.$set(this.formData.oldMeter, 'meterUserAccountNumAfterChange', '')
      }
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      // 报修 系统用户 换表换表
      if (
        this.formData?.model?.repairCreateOrderUserType == 1 &&
        this.formData?.model?.ifNeedChangeMeter == 1 &&
        (this.formData?.newMeter?.newMeterId === '' || this.formData?.newMeter?.newMeterId === undefined)
      ) {
        this.$message.warning(this.$t('请选择新表数据'))
        return
      }
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          let message = ''

          let params = {}
          if (this.optionType == '处理') {
            httpurl += this.url.pass
            method = 'post'
            message = this.$t('处理成功')
            // 报修

            params = {
              dataId: that.formData.model.id,
              createTicketDTO: {
                repairPicture: that.formData.model.repairPicture,
                resolvedPictureFront: that.formData.model.resolvedPictureFront,
                resolvedPictureOpposite: that.formData.model.resolvedPictureOpposite,
                infoPicture: that.formData.model.infoPicture,

                ticketsRepairReq: {
                  id: that.formData.model.bzId ? that.formData.model.bzId : '',
                  repairName: that.formData.model.repairName,
                  repairPhone: that.formData.model.repairPhone,
                  repairAddress: that.formData.model.repairAddress,
                  repairTime: that.formData.model.repairTime,
                  repairPicture: that.formData.model.repairPicture,
                  repairDescription: that.formData.model.repairDescription,

                  solveStatus: 1,
                  // fixPhone: that.formData.model.fixPhone,
                  // fixDescription: that.formData.model.fixDescription,
                  // fixPicture: that.formData.model.fixPicture,
                  handleUserName: that.formData.model.handleUserName,
                  handleUserRealName: that.formData.model.handleUserRealName,
                  handleUserPhone: that.formData.model.handleUserPhone,
                  handleUserDescription: that.formData.model.handleUserDescription,
                  handleUserTime: that.formData.model.handleUserTime,
                  resolvedPictureFront: that.resolvedPictureFront, // 处理照片
                  resolvedPictureOpposite: that.resolvedPictureOpposite, // 处理照片
                  userId: that.formData.model.userId,
                  userName: that.formData.model.userName,
                  userIdNumber: that.formData.model.userIdNumber,
                  mtName: that.formData.model.mtName,
                  userPhone: that.formData.model.userPhone,
                  ifNeedChangeMeter: that.formData.model.ifNeedChangeMeter, // 是否换表
                  /*
                      meterId: that.formData.model.meterId, // 旧表ID
                      repairCreateOrderUserType: that.repairCreateOrderUserType, // 用户类型
                      ifNeedChangeMeter: that.model.ifNeedChangeMeter, // 是否换表
                      whetherSettlementOldTable: that.model.whetherSettlementOldTable,// 是否以旧表机械读数结算
                      meterUserAccountNumAfterChange: that.model.meterUserAccountNumAfterChange, // 剩余金额(元)
                      meterOldMachineSumFlow: that.model.meterOldMachineSumFlow, // 旧表机械读数
                      oldPicture: that.model.oldPicture, // 旧表照片
                      newMeterId:  that.model.newMeterId, // 新表ID
                      newPicture: that.model.newPicture, // 新表照片
                      meterStartNum: that.model.meterStartNum, // 新表开始计费读数
                      payOrNot: that.model.payOrNot, // 是否收费
                      resolvedPicture: that.model.resolvedPicture, // 支付凭证
                      repairRemark: that.model.repairRemark, // 最后的备注
                      */
                },
                ticketsChangeMeterReq: {
                  oldMeterBalances: that.formData.oldMeter.oldMeterBalances,
                  changingMeterReason: that.formData.model.changingMeterReason,
                  changingMeterReasonDetail: that.formData.model.changingMeterReasonDetail,
                  userAccountNum: that.formData.oldMeter.userAccountNum, // 末次结算余额
                  userMeterStartNum: that.formData.oldMeter.userMeterStartNum, // 旧表 计费起始读数
                  oldMeterStartNum: that.formData.oldMeter.oldMeterStartNum, // 旧表 计费起始读数
                  meterUpTime: that.formData.oldMeter.meterUpTime, // 旧表 计费起始读数
                  meterTotalUse: '',
                  oldUserCalNum: that.formData.oldMeter.oldUserCalNum, // 末次结算
                  meterUserAccountNumAfterChange: that.formData.oldMeter.meterUserAccountNumAfterChange, // 剩余金额(元)
                  meterOldSumFlowAfterChange: that.formData.oldMeter.meterOldSumFlowAfterChange,
                  userKeyId: that.formData.oldMeter.id ? that.formData.oldMeter.id : that.formData.model.userKeyId,
                  userId: that.formData.model.userId,
                  meterOldMachineSumFlow: that.formData.oldMeter.meterOldMachineSumFlow, // 旧表机械读数
                  whetherSettlementOldTable: that.formData.oldMeter.whetherSettlementOldTable, // 是否以旧表机械读数结算
                  oldMeterId: that.formData.oldMeter.meterId, // 旧表ID
                  // oldPicture: that.formData.oldMeter.oldPicture, // 旧表照片
                  newMeterId: that.formData.newMeter.newMeterId, // 新表ID
                  // newPicture: that.model.newPicture, // 新表照片
                  meterStartNum: that.formData.newMeter.meterStartNum, // 新表开始计费读数
                  payOrNot: that.formData.model.payOrNot, // 是否收费
                  resolvedPictureFront: that.formData.model.resolvedPictureFront, // 处理前照片
                  resolvedPictureOpposite: that.formData.model.resolvedPictureOpposite, // 处理前照片
                  remark: that.formData.model.remark, // 最后的备注
                },
              },
              comment: that.notInputRemark,
            }
            if(that.formData.model.payOrNot == 1){
              params.createTicketDTO.ticketsChangeMeterReq.feeAmount = that.formData.model.feeAmount;
              params.createTicketDTO.ticketsChangeMeterReq.protocolPicture = that.formData.model.protocolPicture;
            }
            /*
              debugger
              // 报修
              this.$set(params,'dataId',that.formData.model.id);

              this.$set(params,'ticketsFrom',that.formData.model.ticketsFrom);
              this.$set(params,'ticketsState',that.formData.model.ticketsState);
              this.$set(params,'userKeyId',that.formData.model.userKeyId);
              this.$set(params,'userId',that.formData.model.userId);
              // this.$set(params,'ifNeedChangeMeter',that.formData.model.yesOrNotChangeMeter);// 是否换表
              // this.$set(params,'repairPicture',that.model.repairPicture);// 报修照片
              // this.$set(params,'resolvedPicture',that.model.resolvedPicture);// 处理照片
              this.$set(params,'infoPicture',that.formData.model.infoPicture);// 支付凭证

              params.ticketsRepairReq = {
                  id: params.bzId ? params.bzId : '',
                  repairName: params.repairName,
                  repairPhone: params.repairPhone,
                  repairAddress: params.repairAddress,
                  repairTime: params.repairTime,
                  repairPicture: params.repairPicture,
                  repairDescription: params.repairDescription,

                  solveStatus: 1,
                  // fixPhone: params.fixPhone,
                  // fixDescription: params.fixDescription,
                  // fixPicture: params.fixPicture,
                  handleUserName: params.handleUserName,
                  handleUserRealName: params.handleUserRealName,
                  handleUserPhone: params.handleUserPhone,
                  handleUserDescription: params.handleUserDescription,
                  handleUserTime: params.handleUserTime,
                  resolvedPicture: that.resolvedPicture, // 处理照片
                  userId: params.userId,
                  userName: params.userName,
                  userIdNumber: params.userIdNumber,
                  mtName: params.mtName,
                  userPhone: params.userPhone,
                  ifNeedChangeMeter: params.ifNeedChangeMeter, // 是否换表

                  meterId: params.meterId, // 旧表ID
                  repairCreateOrderUserType: that.repairCreateOrderUserType, // 用户类型
                  ifNeedChangeMeter: that.model.ifNeedChangeMeter, // 是否换表
                  whetherSettlementOldTable: that.model.whetherSettlementOldTable,// 是否以旧表机械读数结算
                  meterUserAccountNumAfterChange: that.model.meterUserAccountNumAfterChange, // 剩余金额(元)
                  meterOldMachineSumFlow: that.model.meterOldMachineSumFlow, // 旧表机械读数
                  oldPicture: that.model.oldPicture, // 旧表照片
                  newMeterId:  that.model.newMeterId, // 新表ID
                  newPicture: that.model.newPicture, // 新表照片
                  meterStartNum: that.model.meterStartNum, // 新表开始计费读数
                  payOrNot: that.model.payOrNot, // 是否收费
                  resolvedPicture: that.model.resolvedPicture, // 支付凭证
                  repairRemark: that.model.repairRemark, // 最后的备注
                  
              };


              params.ticketsChangeMeterReq = {
                  oldMeterBalances : that.formData.oldMeter.oldMeterBalances,
                  changingMeterReason: params.changingMeterReason,
                  changingMeterReasonDetail: params.changingMeterReasonDetail,
                  userAccountNum: params.userAccountNum,
                  meterTotalUse: "",
                  oldMeterStartNum: that.formData.oldMeter.oldMeterStartNum,
                  oldUserCalNum: that.formData.oldMeter.oldUserCalNum,
                  meterStartNum: "", 
                  meterUserAccountNumAfterChange: that.formData.oldMeter.meterUserAccountNumAfterChange, // 剩余金额(元)
                  meterOldSumFlowAfterChange: that.formData.oldMeter.meterOldSumFlowAfterChange,
                  userKeyId: params.userKeyId,
                  userId: params.userId,
                  meterOldMachineSumFlow: that.formData.oldMeter.meterOldMachineSumFlow, // 旧表机械读数
                  whetherSettlementOldTable: that.formData.oldMeter.whetherSettlementOldTable, // 是否以旧表机械读数结算
                  oldMeterId: that.formData.oldMeter.meterId, // 旧表ID
                  // oldPicture: that.formData.oldMeter.oldPicture, // 旧表照片
                  newMeterId:  that.formData.newMeter.newMeterId, // 新表ID
                  // newPicture: that.model.newPicture, // 新表照片
                  meterStartNum: that.formData.newMeter.meterStartNum, // 新表开始计费读数
                  payOrNot: that.formData.model.payOrNot, // 是否收费
                  resolvedPicture: that.formData.model.resolvedPicture, // 支付凭证
                  repairRemark: that.formData.model.repairRemark, // 最后的备注
              }
              console.log("当前this.model数据",that.formData.model);
              console.log("当前报修提交数据",params);
*/
          } else {
            // 审核
            httpurl += this.url.pass
            method = 'post'
            message = this.$t('处理成功')
            // 需要换表 审核时
            if (that.formData.model.ifNeedChangeMeter == 1) {
              params = {
                dataId: that.formData.model.id,
                createTicketDTO: {
                  ticketsChangeMeterReq: {
                    whetherSettlementOldTable: that.formData.oldMeter.whetherSettlementOldTable, // 是否以旧表机械读数结算
                    meterUserAccountNumAfterChange: that.formData.oldMeter.meterUserAccountNumAfterChange, // 剩余金额(元)
                    meterStartNum: that.formData.newMeter.meterStartNum, // 新表开始计费读数
                  },
                },
                comment: that.notInputRemark,
              }
            } else {
              params = {
                dataId: that.formData.model.id,
                comment: that.notInputRemark,
              }
            }
          }
          httpAction(httpurl, params, method)
            .then(res => {
              if (res.success) {
                that.$message.success(message)
                that.$emit('ok')
                this.visible = false
              } else {
                that.$message.warning(res.message)
              }
              that.confirmLoading = false
            })
            .finally(() => {
              that.confirmLoading = false
            })
        } else {
          this.$message.warning(this.$t('存在必填内容未填！'))
        }
      })
    },
    meterOldMachineSumFlowInput() {
      if (this.formData.oldMeter.whetherSettlementOldTable == 1) {
        let params = {
          meterOldMachineSumFlow: this.formData.oldMeter.meterOldMachineSumFlow,
          userId: this.formData.oldMeter.userId,
          meterIdOld: this.formData.oldMeter.meterId ? this.formData.oldMeter.meterId : this.formData.model.meterId,
          userKeyId: this.formData.oldMeter.id ? this.formData.oldMeter.id : this.formData.model.userKeyId,
        }
        httpAction(this.url.useOldMachineSumFlow, params, 'put').then(res => {
          if (res.success) {
            this.$set(this.formData.oldMeter, 'meterUserAccountNumAfterChange', res.result)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    // 选择新表
    selectNewMeter() {
      this.selectNewMeterModalVisible = true
    },
    handleMeterSelected(selectedMeter) {
      this.selectedMeter = selectedMeter
      // 新表编号
      this.formData.newMeter.newMeterId = selectedMeter.meterId
      // 新表口径
      this.formData.newMeter.newMtCaliber = selectedMeter.mtCaliber
      // 新表厂商 =
      this.formData.newMeter.newMtName = selectedMeter.mtName

      console.log('选中的表信息:', selectedMeter)
      // 这里可以处理选中的表信息，比如保存到父组件的数据中
    },
    // 切换 是否换表 初始化
    handleChangeIfNeedChangeMeter() {
      this.$set(this.formData.oldMeter, 'meterOldMachineSumFlow', '')
      this.$set(this.formData.oldMeter, 'whetherSettlementOldTable', null)
      this.$set(this.formData.oldMeter, 'meterUserAccountNumAfterChange', '')

      // 新表数据初始化
      this.$set(this.formData.newMeter, 'newMeterId', '')
      this.$set(this.formData.newMeter, 'newMtCaliber', '')
      this.$set(this.formData.newMeter, 'newMtName', '')
      this.$set(this.formData.newMeter, 'meterStartNum', '')
      this.$set(this.formData.model, 'payOrNot', 0)
      // 清空表单校验
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    displayRender({ labels }) {
      return labels[labels.length - 1]
    },
    onChange(value) {
      // value 是级联选择器的完整路径数组，如 ["1", "2", "3"]
      if (value && value.length > 0) {
        // 获取最后一层的值
        const lastValue = value[value.length - 1]
        // 存储到 formReason 字段
        this.$set(this.formData.model, 'changingMeterReason', lastValue)
      }
    },
    // 根据最后一层值查找完整路径
    findCascaderPath(leafValue) {
      const findPathRecursive = (node, path = []) => {
        // 判断当前节点是否匹配
        if (String(node.value) === String(leafValue)) {
          return [...path, node.value] // 返回当前路径
        }

        // 如果有子节点，继续递归查找
        if (node.children) {
          for (let child of node.children) {
            const result = findPathRecursive(child, [...path, node.value])
            if (result) {
              return result // 找到路径，返回
            }
          }
        }

        return null // 没找到，返回 null
      }

      // 遍历 options，查找路径
      for (let item of this.options) {
        const result = findPathRecursive(item)
        if (result) {
          return result // 找到路径，返回
        }
      }

      return [] // 如果没找到路径，返回空数组
    },
    getTagColor(value) {
      switch (value) {
        case 0:
          return 'red'
        case 1:
          return 'orange'
        case 2:
          return 'yellow'
        case 3:
          return 'blue'
        default:
          return 'default' // 你可以设置一个默认颜色
      }
    },
    setJJ(item) {
      return filterDictTextByCache('ticketsEmergency', item)
    },
    payOrNotChange() {
      this.formData.model.infoPicture = ''
    },
    whetherSettlementOldTableChange() {
      if (
        this.formData.oldMeter.whetherSettlementOldTable == 1 &&
        this.formData.oldMeter.meterOldMachineSumFlow != null
      ) {
        this.meterOldMachineSumFlowInput()
      } else {
        this.$set(this.formData.model, 'meterUserAccountNumAfterChange', null)
      }
    },
    viewSig() {
      this.visibleSig = true
    },
    handleSigCancel() {
      this.visibleSig = false
    },
    downloadSig() {
      this.downloadFile(this.formData.model.electronicSignature, this.$t('签名'))
    },
    downloadFile(url, name) {
      console.log('url==', url)
      var a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', name)
      a.setAttribute('target', '_blank')
      let clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    },
    handleCancel1() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
  },
}
</script>
<style lang="less" scoped>
.box-sig {
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  .mask-sig {
    visibility: hidden;
    position: absolute;
    width: 180px;
    height: 80px;
    top: 10px;
    left: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    cursor: pointer;

    .icon-sig {
      color: rgba(255, 255, 255, 0.85);
      font-size: 16px;
    }
  }
  .mask-show {
    visibility: visible;
    transition: all 0.3s;
  }
}
</style>
